import React from "react";
import { BsCloudDownload } from "react-icons/bs";
import { MdMenuBook, MdOutlineDescription, MdOutlineTheaters } from "react-icons/md";
import { Link } from "react-router-dom";
// import { BsCloudDownload } from "react-icons/bs";


const TrainingExportsSection = ({ id }: any) => {
  return (
    <div className="p-5 flex flex-col justify-center items-center">

      <div className="p-5 mb-5 bg-white rounded-lg shadow-lg w-4/6 flex items-center justify-between hover:scale-105">
        <MdOutlineDescription className="bg-purple-500 rounded-full h-10 w-10 p-2" color="white" />
        <span className="flex-1 text-center text-gray-700 font-medium">Fiche de la formatoin</span>
        <small className="text-gray-300">Non disponible</small>
      </div>
      <div className="p-5 mb-5 bg-white rounded-lg shadow-lg w-4/6 flex items-center justify-between hover:scale-105">
        <MdOutlineTheaters className="bg-purple-500 rounded-full h-10 w-10 p-2" color="white" />
        <span className="flex-1 text-center text-gray-700 font-medium">Script de la formation</span>
        <Link to={`/training/${id}/documents/script`} target="_blank" className="flex flex-col items-center text-blue-500 font-medium">
          <BsCloudDownload />
          <small>Générer</small>
        </Link>
      </div>
      <div className="p-5 mb-5 bg-white rounded-lg shadow-lg w-4/6 flex items-center justify-between hover:scale-105">
        <MdMenuBook className="bg-purple-500 rounded-full h-10 w-10 p-2" color="white" />
        <span className="flex-1 text-center text-gray-700 font-medium">Référentiel de compétences</span>
        <small className="text-gray-300">Non disponible</small>
        {/*<div className="flex flex-col items-center text-blue-500 font-medium">
          <BsCloudDownload />
          <small>Télécharger</small>
          </div>*/}
      </div>
    </div>
  );
}

export default TrainingExportsSection
